// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__2sqO0","control":"Checkout_control__LxuoK","actions":"Checkout_actions__36yOT","submit":"Checkout_submit__1bHiF","invalid":"Checkout_invalid__2aVqx"};